<template>
  <div id="wxUser">
    <!-- 面包屑导航 -->
    <el-breadcrumb
      separator="/"
      style="padding-left: 10px; padding-bottom: 10px; font-size: 12px"
    >
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>微信用户管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 用户列表卡片 -->
    <el-card class="box-card">
      <!-- 搜索表单 -->
      <el-form :inline="true" ref="form" :model="queryMap" label-width="70px">
        <el-form-item label="手机号">
          <el-input
            @keyup.enter.native="searchUser"
            @clear="searchUser"
            clearable
            v-model="queryMap.phone"
            placeholder="请输入手机号查询"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户昵称">
          <el-input
            clearable
            @clear="searchUser"
            v-model="queryMap.nickName"
            placeholder="请输入用户昵称查询"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户状态">
          <el-select
            clearable
            @clear="searchUser"
            v-model="queryMap.userStatus"
            placeholder="请选择用户状态"
          >
            <el-option label="正常" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="代理状态">
          <el-select
            clearable
            @clear="searchUser"
            v-model="queryMap.agentStatus"
            placeholder="请选择代理状态"
          >
            <el-option label="有代理权限" value="1"></el-option>
            <el-option label="无代理权限" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序字段">
          <el-select
            v-model="queryMap.sortField"
            placeholder="请选择排序字段"
            @change="searchUser"
          >
            <el-option label="创建时间" value="createTime"></el-option>
            <el-option label="最后登录时间" value="lastLoginTime"></el-option>
            <el-option label="手机号" value="phone"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序方向">
          <el-select
            v-model="queryMap.sortOrder"
            placeholder="请选择排序方向"
            @change="searchUser"
          >
            <el-option label="升序" value="asc"></el-option>
            <el-option label="降序" value="desc"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-left: 20px">
          <el-button @click="reset" icon="el-icon-refresh">重置</el-button>
          <el-button type="primary" @click="searchUser" icon="el-icon-search"
            >查询</el-button
          >
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="addDialogVisible = true"
            v-hasPermission="'wxUser:add'"
            >添加</el-button
          >
          <el-button
            @click="downExcel"
            v-hasPermission="'wxUser:export'"
            icon="el-icon-download"
            >导出</el-button
          >
        </el-form-item>
      </el-form>

      <!-- 用户表格 -->
      <el-table
        v-loading="loading"
        :data="userList"
        border
        style="width: 100%"
        height="390"
      >
        <el-table-column label="ID" prop="id" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="手机号" prop="phone" width="120"></el-table-column>
        <el-table-column label="OpenID" prop="openid" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column label="用户昵称" prop="nickName" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="用户头像" width="80">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.avatar || 'https://cube.elemecdn.com/3/7c/3f7071cf9287870e355e3be67c110jpeg.jpeg'"
              fit="cover"
              width="40"
              height="40"
              class="avatar-img"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column label="用户状态" width="100">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              type="success"
              v-if="scope.row.userStatus === 1"
              >正常</el-tag
            >
            <el-tag size="mini" type="danger" v-else>禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="代理权限" width="120">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              type="primary"
              v-if="scope.row.agentStatus === 1"
              >有代理权限</el-tag
            >
            <el-tag size="mini" type="info" v-else>无代理权限</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="上级代理ID" prop="parentUserId" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="顶级代理ID" prop="topAgentId" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="创建时间" prop="createTime" width="180">
          <template slot-scope="scope">
            {{ scope.row.createTime ? $moment(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss') : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="最后登录" prop="lastLoginTime" width="180">
          <template slot-scope="scope">
            {{ scope.row.lastLoginTime ? $moment(scope.row.lastLoginTime).format('YYYY-MM-DD HH:mm:ss') : '-' }}
          </template>
        </el-table-column>
        
        <!-- 操作列 -->
        <el-table-column label="操作" width="380">
          <template slot-scope="scope">
            <el-button
              v-hasPermission="'wxUser:edit'"
              size="mini"
              type="primary"
              icon="el-icon-edit-outline"
              @click="edit(scope.row.id)"
            >编辑</el-button>
            <el-button
              v-hasPermission="'wxUser:delete'"
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="del(scope.row.id)"
            >删除</el-button>
            <el-button
              v-hasPermission="'wxUser:updateStatus'"
              size="mini"
              :type="scope.row.userStatus === 1 ? 'warning' : 'success'"
              @click="updateUserStatus(scope.row.id, scope.row.userStatus === 1 ? 0 : 1)"
            >
              {{ scope.row.userStatus === 1 ? '禁用' : '启用' }}
            </el-button>
            <el-button
              v-hasPermission="'wxUser:updateAgentStatus'"
              size="mini"
              :type="scope.row.agentStatus === 1 ? 'info' : 'success'"
              @click="updateAgentStatus(scope.row.id, scope.row.agentStatus === 1 ? 0 : 1)"
            >
              {{ scope.row.agentStatus === 1 ? '取消代理' : '设置代理' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <el-pagination
        style="margin-top: 10px"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryMap.pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryMap.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>

    <!-- 添加用户弹窗 -->
    <el-dialog
      title="添加微信用户"
      @close="closeDialog"
      :visible.sync="addDialogVisible"
      width="60%;"
    >
      <el-form :model="addForm" ref="addFormRef" label-width="100px" :rules="addFormRules">
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="addForm.phone" placeholder="请输入11位手机号"></el-input>
        </el-form-item>
        <el-form-item label="OpenID" prop="openid">
          <el-input v-model="addForm.openid" placeholder="请输入微信openid"></el-input>
        </el-form-item>
        <el-form-item label="用户昵称" prop="nickName">
          <el-input v-model="addForm.nickName" placeholder="请输入用户昵称"></el-input>
        </el-form-item>
        <el-form-item label="用户头像" prop="avatar">
          <el-input v-model="addForm.avatar" placeholder="请输入头像URL"></el-input>
        </el-form-item>
        <el-form-item label="用户状态" prop="userStatus">
          <el-select v-model="addForm.userStatus" placeholder="请选择用户状态">
            <el-option label="正常" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="代理权限" prop="agentStatus">
          <el-select v-model="addForm.agentStatus" placeholder="请选择代理权限">
            <el-option label="有代理权限" value="1"></el-option>
            <el-option label="无代理权限" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上级用户ID" prop="parentUserId">
          <el-input v-model="addForm.parentUserId" placeholder="请输入上级用户ID（可选）"></el-input>
        </el-form-item>
        <el-form-item label="顶级代理ID" prop="topAgentId">
          <el-input v-model="addForm.topAgentId" placeholder="有代理权限时自动填充（可选）"></el-input>
        </el-form-item>
        
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="addUser" :loading="btnLoading">确定</el-button>
        </div>
      </el-form>
    </el-dialog>

    <!-- 编辑用户弹窗 -->
    <el-dialog
      title="修改微信用户"
      :visible.sync="editDialogVisible"
      width="60%"
      @close="editClose"
    >
      <el-form :model="editForm" ref="editFormRef" label-width="100px" :rules="editFormRules">
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="editForm.phone" placeholder="请输入11位手机号"></el-input>
        </el-form-item>
        <el-form-item label="OpenID" prop="openid">
          <el-input v-model="editForm.openid" placeholder="请输入微信openid"></el-input>
        </el-form-item>
        <el-form-item label="用户昵称" prop="nickName">
          <el-input v-model="editForm.nickName" placeholder="请输入用户昵称"></el-input>
        </el-form-item>
        <el-form-item label="用户头像" prop="avatar">
          <el-input v-model="editForm.avatar" placeholder="请输入头像URL"></el-input>
        </el-form-item>
        <el-form-item label="用户状态" prop="userStatus">
          <el-select v-model="editForm.userStatus" placeholder="请选择用户状态">
            <el-option label="正常" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="代理权限" prop="agentStatus">
          <el-select v-model="editForm.agentStatus" placeholder="请选择代理权限">
            <el-option label="有代理权限" value="1"></el-option>
            <el-option label="无代理权限" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上级用户ID" prop="parentUserId">
          <el-input v-model="editForm.parentUserId" placeholder="请输入上级用户ID（可选）"></el-input>
        </el-form-item>
        <el-form-item label="顶级代理ID" prop="topAgentId">
          <el-input v-model="editForm.topAgentId" placeholder="有代理权限时自动填充（可选）"></el-input>
        </el-form-item>
        
        <div slot="footer" class="dialog-footer">
          <el-button @click="editClose">取消</el-button>
          <el-button type="primary" @click="updateUser" :loading="btnLoading">确定</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    // 手机号校验规则
    const checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[3-9]\d{9}$/;
      if (!value) {
        return callback(new Error("手机号不能为空"));
      }
      if (!phoneReg.test(value)) {
        callback(new Error("请输入正确的11位手机号"));
      } else {
        callback();
      }
    };

    // OpenID校验规则
    const checkOpenid = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("OpenID不能为空"));
      }
      if (value.length > 64) {
        callback(new Error("OpenID长度不能超过64个字符"));
      } else {
        callback();
      }
    };

    return {
      btnLoading: false,
      btnDisabled: false,
      loading: true,
      total: 0,
      addDialogVisible: false,
      editDialogVisible: false,
      userList: [],
      
      // 查询条件
      queryMap: {
        pageNum: 1,
        pageSize: 20,
        phone: "",
        nickName: "",
        userStatus: "",
        agentStatus: "",
        sortField: "",
        sortOrder: "",
      },
      
      // 新增表单
      addForm: {
        phone: "",
        openid: "",
        nickName: "",
        avatar: "",
        userStatus: 1, // 默认正常
        agentStatus: 0, // 默认无代理
        parentUserId: "",
        topAgentId: "",
      },
      
      // 编辑表单
      editForm: {},
      
      // 表单校验规则
      addFormRules: {
        phone: [
          { required: true, trigger: "blur", validator: checkPhone },
        ],
        openid: [
          { required: true, trigger: "blur", validator: checkOpenid },
        ],
        nickName: [
          { max: 50, message: "昵称长度不能超过50个字符", trigger: "blur" },
        ],
        avatar: [
          { max: 255, message: "头像URL长度不能超过255个字符", trigger: "blur" },
        ],
        userStatus: [
          { required: true, message: "请选择用户状态", trigger: "blur" },
        ],
        agentStatus: [
          { required: true, message: "请选择代理权限", trigger: "blur" },
        ],
        parentUserId: [
          { max: 50, message: "上级用户ID长度不能超过50个字符", trigger: "blur" },
        ],
        topAgentId: [
          { max: 50, message: "顶级代理ID长度不能超过50个字符", trigger: "blur" },
        ],
      },
      
      // 编辑表单校验规则（复用新增规则）
      editFormRules: {},
    };
  },

  created() {
    // 初始化编辑表单验证规则
    this.editFormRules = JSON.parse(JSON.stringify(this.addFormRules));
    this.getUserList();
    setTimeout(() => {
      this.loading = false;
    }, 500);
  },

  methods: {
    // 重置查询条件
    reset() {
      this.queryMap = {
        pageNum: 1,
        pageSize: 20,
        phone: "",
        nickName: "",
        userStatus: "",
        agentStatus: "",
        sortField: "",
        sortOrder: "",
      };
      this.searchUser();
    },

    // 导出Excel
    downExcel() {
      axios
        .request({
          url: "/wxUser/excel",
          method: "post",
          responseType: "blob",
        })
        .then((res) => {
          if (res.headers["content-type"] === "application/json") {
            return this.$message.error("无导出权限");
          }
          const data = res.data;
          let url = window.URL.createObjectURL(data);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.href = url;
          a.download = "微信用户列表.xlsx";
          a.click();
          window.URL.revokeObjectURL(url);
        });
    },

    // 获取用户列表
    async getUserList() {
      this.loading = true;
      try {
        const { data: res } = await this.$http.get("wxUser/list", {
          params: this.queryMap,
        });
        if (res.code !== 200) {
          this.$message.error("获取用户列表失败：" + res.msg);
          return;
        }
        this.total = res.data.total;
        this.userList = res.data.rows;
      } catch (error) {
        this.$message.error("获取用户列表异常：" + error.message);
      } finally {
        this.loading = false;
      }
    },

    // 搜索用户
    searchUser() {
      this.queryMap.pageNum = 1;
      this.getUserList();
    },

    // 删除用户
    async del(id) {
      var res = await this.$confirm(
        "此操作将永久删除该用户, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch(() => {
        this.$message({ type: "info", message: "已取消删除" });
      });
      if (res === "confirm") {
        try {
          const { data: res } = await this.$http.delete(`wxUser/delete/${id}`);
          if (res.code === 200) {
            this.$notify.success({ title: "操作成功", message: "用户删除成功" });
            this.getUserList();
          } else {
            this.$message.error("用户删除失败:" + res.msg);
          }
        } catch (error) {
          this.$message.error("用户删除异常:" + error.message);
        }
      }
    },

    // 新增用户
    async addUser() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return;
        this.btnLoading = true;
        this.btnDisabled = true;
        try {
          const { data: res } = await this.$http.post("wxUser/add", this.addForm);
          if (res.code === 200) {
            this.$notify.success({ title: "操作成功", message: "用户添加成功" });
            this.closeDialog();
            this.getUserList();
          } else {
            this.$message.error("用户添加失败:" + res.msg);
          }
        } catch (error) {
          this.$message.error("用户添加异常:" + error.message);
        } finally {
          this.btnLoading = false;
          this.btnDisabled = false;
        }
      });
    },

    // 编辑用户
    async edit(id) {
      try {
        const { data: res } = await this.$http.get(`wxUser/edit/${id}`);
        if (res.code === 200) {
          this.editForm = { ...res.data };
          this.editDialogVisible = true;
        } else {
          this.$message.error("获取用户详情失败:" + res.msg);
        }
      } catch (error) {
        this.$message.error("获取用户详情异常:" + error.message);
      }
    },

    // 更新用户信息
    async updateUser() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return;
        this.btnLoading = true;
        this.btnDisabled = true;
        try {
          const { data: res } = await this.$http.put(`wxUser/update/${this.editForm.id}`, this.editForm);
          if (res.code === 200) {
            this.$notify({ title: "操作成功", message: "用户信息已更新", type: "success" });
            this.editClose();
            this.getUserList();
          } else {
            this.$message.error("用户更新失败:" + res.msg);
          }
        } catch (error) {
          this.$message.error("用户更新异常:" + error.message);
        } finally {
          this.btnLoading = false;
          this.btnDisabled = false;
        }
      });
    },

    // 修改用户状态（启用/禁用）
    async updateUserStatus(id, status) {
      const statusText = status === 1 ? "启用" : "禁用";
      var res = await this.$confirm(
        `确定要${statusText}该用户吗?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch(() => {
        this.$message({ type: "info", message: `已取消${statusText}` });
      });
      if (res === "confirm") {
        try {
          const { data: res } = await this.$http.put(`wxUser/updateUserStatus/${id}`, {}, {
            params: { userStatus: status }
          });
          if (res.code === 200) {
            this.$notify.success({ title: "操作成功", message: `用户${statusText}成功` });
            this.getUserList();
          } else {
            this.$message.error(`用户${statusText}失败:` + res.msg);
          }
        } catch (error) {
          this.$message.error(`用户${statusText}异常:` + error.message);
        }
      }
    },

    // 修改代理状态（设置/取消代理）
    async updateAgentStatus(id, status) {
      const statusText = status === 1 ? "设置为代理" : "取消代理";
      var res = await this.$confirm(
        `确定要${statusText}吗?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch(() => {
        this.$message({ type: "info", message: `已取消${statusText}` });
      });
      if (res === "confirm") {
        try {
          const { data: res } = await this.$http.put(`wxUser/updateAgentStatus/${id}`, {}, {
            params: { agentStatus: status }
          });
          if (res.code === 200) {
            this.$notify.success({ title: "操作成功", message: `${statusText}成功` });
            this.getUserList();
          } else {
            this.$message.error(`${statusText}失败:` + res.msg);
          }
        } catch (error) {
          this.$message.error(`${statusText}异常:` + error.message);
        }
      }
    },

    // 分页大小改变
    handleSizeChange(newSize) {
      this.queryMap.pageSize = newSize;
      this.getUserList();
    },

    // 当前页改变
    handleCurrentChange(current) {
      this.queryMap.pageNum = current;
      this.getUserList();
    },

    // 关闭新增弹窗
    closeDialog() {
      this.$refs.addFormRef?.clearValidate();
      this.addForm = {
        phone: "",
        openid: "",
        nickName: "",
        avatar: "",
        userStatus: 1,
        agentStatus: 0,
        parentUserId: "",
        topAgentId: "",
      };
      this.addDialogVisible = false;
    },

    // 关闭编辑弹窗
    editClose() {
      this.$refs.editFormRef?.clearValidate();
      this.editForm = {};
      this.editDialogVisible = false;
    },
  },
};
</script>

<style scoped>
/* 头像样式 */
.avatar-img {
  border-radius: 50%;
  cursor: pointer;
}
.avatar-img:hover {
  border: 1px solid #409eff;
}

/* 弹窗表单样式 */
.el-form-item {
  margin-bottom: 20px;
}
</style>